// store/balance/balanceInitialState.ts

import { BalanceQueryParams, BalanceDto, Compte } from '../../types';
import { FilterBalanceType } from '../../components/Balance/FilterType';
import { BalanceRow } from '../../components/Balance/Balance';

/**
 * @french
 * Initialise les filtres sauvegardés avec des valeurs par défaut.
 */
const getInitialSavedFilters = (): Map<FilterBalanceType, any> => {
  return new Map<FilterBalanceType, any>([
    [FilterBalanceType.GENERAL, true],
    [FilterBalanceType.IMMO, false],
    [FilterBalanceType.CLIENTS, false],
    [FilterBalanceType.FOURNISSEURS, false],
    [FilterBalanceType.BANQUE, false],
    [FilterBalanceType.EXPLOITATIONS, false],
    [FilterBalanceType.COMPTABILITE_STANDARD, true],
    [FilterBalanceType.COMPTABILITE_ANALYTIQUE, false],
  ]);
};

/**
 * @french
 * État initial du slice de balance.
 */
export const balanceInitialState = {
  selectedBalance: null as BalanceDto | null,
  selectedBalances: [] as BalanceRow[],
  savedFilters: getInitialSavedFilters(),
  selectedCompte: null as Compte | null,
  exportModalVisible: false,
  isReaffectationModalVisible: false,
  modalTransferVisible: false,
  filterLettrageActivation: false,
};

/**
 * @french
 * Type dérivé de l’état initial.
 */
export type BalanceState = typeof balanceInitialState;
